
import React from 'react'
import './disclaimer.css';

const Disclaimer = () => {
  return (
    <div className="disclaimer" >
        <h1>Disclaimer</h1>
        <p>All the information on this website is published in good faith and for general informational purposes only. Any action you take upon the information you find on this website is strictly at your own risk. QuizInc will not be liable for any losses and/or damages in connection with the use of our website.
        <br/><br/>
        From our website, you can visit other websites by following hyperlinks to external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation or endorsement of the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove links that may have gone 'bad.'
        <br/>
        <br/><br/>
        Please note that when you leave our website, other sites may have different privacy policies and terms that are beyond our control. Be sure to review the Privacy Policies and "Terms of Service" of these websites before engaging in any business or sharing any personal information.
        </p>
        <br/><br/>
        <h2>Consent</h2>
        
        <p>
        By using our website, you hereby consent to our Privacy Policy and agree to its terms. Should we update, amend or make any changes to this document, those changes will be prominently posted here.
        </p>
    </div>
  )
}

export default Disclaimer